import httpClient from '@/lib/httpClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

/** Deletes a category group; its categories move back to the top level. */
export default function useDeleteTransactionCategoryGroup() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: ({ id }: { id: string | number }) =>
      httpClient.delete(`team/transaction-category/group/${id}`),
    onSuccess: () => {
      toast.success('Group deleted')
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
    },
    onError: (error: any) =>
      toast.error(error?.response?.data?.message ?? 'An error occurred.'),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
